<template>
  <div  id="app">
    <nav class="navbar navbar-dark bg-dark justify-content-between">
      <a class="navbar-brand" href="#">O&M SiD Workshop</a>
      <form class="form-inline">
        <b-button :pressed="isViewHazards" variant="outline-light" sm class="my-sm-0" v-on:click="openViewHazards()">View Hazards</b-button>
      </form>
    </nav>
    <HazardList v-show="isViewHazards"/>
    <section v-show="!isViewHazards">
      <div class="row">
        <div class="col-9" id="mapContainer">
          <button type="button" id="addHazardButton" v-on:click="openAddNewHazard()" class="btn btn-dark">Add Hazard <i class="fa fa-comment-dots"></i></button>
          <Map/>
        </div>
        <template v-if="!isAddNewHazard">
          <div class="col-3 displayNone sideContainer border" id="flexContainer">
            <FlexContainer/>
          </div>
        </template>

          <template v-if="isAddNewHazard">
            <div class="col-6 border sideContainer">
              <NewHazard/>
            </div>
          </template>
          <template v-else>
            <div class="col-3 border sideContainer">
              <SideMenu/>
            </div>
          </template>
      </div>
    </section>


    <notifications group="errors" classes="vue-notification text-dark" :reverse="true"/>
    <notifications group="successNotifications" classes="vue-notification text-dark" :reverse="true"/>
  </div>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";

import Map from './components/Map.vue'
import SideMenu from './components/SideMenu.vue'
import NewHazard from './components/NewHazard.vue'
import FlexContainer from './components/FlexContainer.vue'

import HazardList from './components/HazardList.vue'

import mapStateModule from "./state/modules/mapStateModule.js"

const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    mapModule: mapStateModule,
  },
  strict: debug
})

export default {
  name: 'app',
  data () {
    return {
      isViewHazards: false
      // isAddNewHazard: false
    }
  },
  components: {
    Map,
    SideMenu,
    FlexContainer,
    NewHazard,
    HazardList
  },
  store:store,
  computed: {
    isAddNewHazard: {
      get() {
        return this.$store.state.mapModule.isAddNewHazard
      }
    },
  },
  methods: {
    openAddNewHazard: function() {
      const current = this
      // current.isAddNewHazard = !current.isAddNewHazard
      // current.isAddNewHazard = !(current.$store.state.mapModule.isAddNewHazard)
      current.$store.commit("mapModule/setIfAddNewHazardClicked", !(current.$store.state.mapModule.isAddNewHazard))
      var view =  document.getElementById("map").__vue__.view
      view.graphics.removeAll()
      var flexContainer = document.getElementById("flexContainer")
      var map = document.getElementById("mapContainer")
      if (flexContainer) {
        flexContainer.classList.add("displayNone")
        map.classList.remove("col-6")
        map.classList.add("col-9")
      }
      if (current.isAddNewHazard) {
        map.classList.remove("col-9")
        map.classList.add("col-6")
      }
      else {
        map.classList.remove("col-6")
        map.classList.add("col-9")
      }
    },
    openViewHazards: function() {
      const current = this
      current.isViewHazards = !current.isViewHazards
    }
  }
}
</script>

<style>
.esri-icon-non-visible::before {
  content: "\e610" !important;
}
.esri-icon-visible::before {
  content: "\e611" !important;
}
.displayNone {
  display:none;
}
.sideContainer {
  /* border-style: ridge; */
  padding-left: 0!important;
  padding-right: 0!important;
}
div#mapContainer {
  /* padding-left: 0!important; */
  padding-right: 0!important;
}
/* html,body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
} */
#app {
  overflow: hidden;
  /* display: flex;
  flex-direction: column; */
  /* padding: 0;
  margin: 0;
  width: 100%;
  height: 100%; */
}
</style>
